import styled from 'styled-components'
import { EmptyData } from '@intelie/ui'

export const Table = styled.div`
    margin-bottom: 32px;
`
export const Action = styled.div`
    align-items: baseline;
    display: none;
    justify-content: space-between;

    button {
        background: none;
        border: none;
        margin: 0;
        padding: 0;
    }

    & > *:not(:last-child) {
        margin: 0 10px 0 0;
    }

    .text-primary {
        color: ${({ theme }) => theme['link-button']} !important;
    }
`

export const BaseRow = styled.div`
    display: grid;
    grid-template-columns: 0.5fr 2fr 2fr 2fr 1fr 0.5fr 0.5fr 2fr;

    & > * {
        padding: 16px;
    }
`

export const HeadRow = styled(BaseRow)`
    border-bottom: 1px solid ${({ theme }) => theme['light-borders']};
    color: ${({ theme }) => theme.gray};
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 13px;
    user-select: none;
    text-transform: uppercase;

    & > * {
        align-items: center;
        display: flex;
    }
`

export const BodyRow = styled(BaseRow)`
    border-bottom: 1px solid ${({ theme }) => theme['full-page-background']};
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
    }

    .info-icon {
        position: relative;
        //display: inline-block;
    }

    .tooltip {
        position: absolute;
        top: 0;
        left: 50%;
        background-color: var(--gray-500);
        color: #fff;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 14px;
        white-space: nowrap; /* Prevent line breaks */
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .fa-ul {
        list-style: circle;
        margin: 0;
        padding: 0;
    }

    .fa-ul li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.1rem;
    }

    .orphanWellboreName {
        font-weight: bold;
        padding-right: 30px;
    }

    .actionToggle {
        display: inline-flex;
        font-weight: bold;
        align-items: flex-start;
        justify-content: left;
    }

    .info-icon:hover .tooltip {
        opacity: 1;
    }

    &:hover {
        background-color: var(--blue-200);

        & > a {
            color: var(--gray-800);
        }

        ${Action} {
            display: flex;
        }
    }
`

export const StyledEmptyData = styled(EmptyData)`
    height: 178px;
`
